import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import SecuritySettings from "./Components/AccountSettings/SecuritySettings";
import Password from "./Components/AccountSettings/Password";
import EmailNotification from "./Components/AccountSettings/EmailNotification";
import SocialAccountDetails from "./Components/AccountSettings/SocialAccountDetails";
import DeleteAccount from "./Components/AccountSettings/DeleteAccount";
import { Link, useParams, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { getuserdata } from "../../services/apiService";
import { oneKlicks } from "../../SDK/oneclick";
import { toast } from "react-toastify";
import { debugLog } from "../../utils/debug";
import AccountSharing from "./Components/AccountSettings/AccountSharing";
import SeoSettings from "./Components/AccountSettings/SeoSettings";
import InvoiceSettings from "./Components/AccountSettings/InvoiceSettings";
import BankAccountDetails from "./Components/AccountSettings/BankAccountDetails";
import DashBordmenu from "../../Uitiles/DashBordmenu";

const AccountSettings = () => {
    const [userdata, setUserdata] = useState({});
    const { sublink } = useParams();
    
    const [tabsest, setTabseset] = useState("Security & Settings");
    const navigate = useNavigate();
    useEffect(() => {
        const userData = localStorage.getItem("userData");
        debugLog("userData", userData);
        if (userData) {
            setUserdata(userData);
        }
    }, []);

    useEffect(() => {
        if (sublink === "Security_&_Settings") {
            setTabseset("Security & Settings");
        } else if (sublink === "Password") {
            setTabseset("Password");
        } else if (sublink === "Email_Notification") {
            setTabseset("Email Notification");
        } else if (sublink === "Social_Account_Details") {
            setTabseset("Social Account Details");
        } else if (sublink === "Account_Sharing") {
            setTabseset("Account Sharing");
        } else if (sublink === "Delete_Account") {
            setTabseset("Delete Account");
        } else if (sublink === "Seo_Settings") {
            setTabseset("Seo Settings");
        } else if (sublink === "Invoice_Settings") {
            setTabseset("Invoice Settings");
        } else if (sublink === "Bank_Account_Details") {
            setTabseset("Bank Account Details");
        }
    }, [sublink]);

    const [localInvoice, setLocalInvoice] = useState({
        id: '',
        user_id: '',
        name: '',
        address: '',
        state: '',
        city: '',
        pincode: '',
        country: '',
        phone: '',
        email: '',
        website: '',
        gst_number: ''
    });

    // Tab to URL mapping
    const tabToUrlMapping = {
        "Security & Settings": "Security_&_Settings",
        "Password": "Password",
        "Email Notification": "Email_Notification",
        "Social Account Details": "Social_Account_Details",
        "Account Sharing": "Account_Sharing",
        "Delete Account": "Delete_Account",
        "Seo Settings": "Seo_Settings",
        "Invoice Settings": "Invoice_Settings",
        "Bank Account Details": "Bank_Account_Details"
    };

    const handleTabClick = (tabName) => {
        setTabseset(tabName);
        const urlPath = tabToUrlMapping[tabName];
        if (urlPath) {
            navigate(`/doctor/accountsettings/${urlPath}`);
        }
    };

    const [oldpassword, setOldpassword] = useState("");
    const [newpassword, setNewpassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");
    const [email, setEmail] = useState("");
    const [oldemail, setOldemail] = useState("");
    const [emailisvalid, setEmailisvalid] = useState(false);
    const [showmenu, setShowmenu] = useState(false);


    const [formData, setFormData] = useState({
        password: '',
        retypePassword: '',
        reason: '',
        description: ''
    });



    useEffect(() => {
        const fetchEmail = async () => {
            const emailData = await getuserdata("email");
            const emailisvalid = await getuserdata("activation_key");
            debugLog('getuserdata email', emailData);
            debugLog('getuserdata emailisvalid', emailisvalid);
            setEmail(emailData);
            setOldemail(emailData);
            setEmailisvalid(emailisvalid);
        };

        fetchEmail();
    }, []);

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();

        // Password validation
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordRegex.test(newpassword)) {
            toast.error("Password must be at least 8 characters long and contain uppercase, lowercase, number and special character");
            return;
        }

        if (newpassword !== confirmpassword) {
            toast.error("New password and confirm password do not match");
            return;
        }

        try {
            const userEmail = await getuserdata("email");
            if (!userEmail) {
                toast.error("User email not found. Please log in again.");
                return;
            }

            const oldpasswordhash = CryptoJS.SHA256(oldpassword).toString();
            const newpasswordhash = CryptoJS.SHA256(newpassword).toString();

            const tableSchema = "";
            const tableName = "users";
            const conditions = {
                "email": userEmail
            };
            const orderBy = "id DESC";
            const search = null;
            const pagination = null;
            const margedata = null;

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            debugLog("response check paswors", response);
            if (response.success && response.data.length > 0) {
                const dbPassword = response.data[0].pass;
                
                // Allow password setting if current DB password is empty/null, or if the old password matches.
                const isCurrentPasswordEmpty = !dbPassword;
                const isOldPasswordCorrect = dbPassword === oldpasswordhash;

                if (isCurrentPasswordEmpty || isOldPasswordCorrect) {
                    const data = {
                        "pass": newpasswordhash
                    };
                    const condition = {
                        "email": userEmail
                    };
                    const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);

                    if (updateData.success) {
                        toast.success("Password updated successfully");
                        // Clear password fields
                        setOldpassword("");
                        setNewpassword("");
                        setConfirmpassword("");
                    } else {
                        toast.error("Failed to update password. Please try again.");
                    }
                } else {
                    toast.error("Current password is incorrect");
                }
            } else {
                toast.error("User record not found in the system");
            }
        } catch (error) {
            toast.error("An error occurred while updating password");
        }
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        debugLog('Email', email);
        const tableSchema = "";
        const tableName = "users";
        const conditions = {
            "email": oldemail
        };
        const orderBy = "id DESC";
        const search = null;
        const pagination = null;
        const margedata = null;
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('response check email', response);
        if (response.success && response.data.length > 0) {
            const data = {
                "email": email
            };
            const condition = {
                id: await getuserdata("id")
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (updateData.success === true) {
                toast.success("Email updated successfully");
            } else {
                toast.error("Failed to update email. Please try again.");
            }
            debugLog('updateData check email', updateData);
        } else {
            toast.error("Email not found");
        }
    };

    const handleDeleteAccount = async (e) => {
        e.preventDefault();
        const passwordhash = CryptoJS.SHA256(formData.password).toString();
        debugLog('formData', formData);
        const tableSchema = "";
        const tableName = "users";
        const conditions = {
            "email": await getuserdata("email"),
            "pass": passwordhash
        };
        const orderBy = "id DESC";
        const search = null;
        const pagination = null;
        const margedata = null;
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('response check delete account', response);
        if (response.success && response.data.length > 0) {
            const data = {
                "status": "2" // 2 is for deleted account
            };
            const condition = {
                "email": await getuserdata("email"),
                "pass": passwordhash
            };
            const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
            debugLog('updateData check delete account', updateData);
            if (updateData.success) {
                const tableSchema = "";
                const tableName = "user_delete_requests";
                const data = {
                    "reason": formData.reason,
                    "description": formData.description,
                    "status": "2",
                    "user_id": await getuserdata("id"),
                    "email": await getuserdata("email"),
                    "deleted_at": new Date().toISOString(),
                    "phone": await getuserdata("phone")
                };
                const condition = {
                    "user_id": await getuserdata("id")
                };
                const updateData = await oneKlicks.update(tableSchema, tableName, data, condition);
                debugLog('updateData check delete account', updateData);
                if (updateData.success) {
                    toast.success("Account deleted successfully");
                    localStorage.removeItem("userData");
                    navigate("/");
                } else {
                    toast.error("Failed to delete account. Please try again.");
                }
            } else {
                toast.error("Failed to delete account. Please try again.");
            }
        } else {
            toast.error("Invalid password");
        }
    };


    const handleAccountSharing = async (e) => {
        e.preventDefault();
        debugLog('formData', formData);
    };

    const handleInvoiceSettings = async (e) => {
        try {
            e.preventDefault();
            const tableSchema = "";
            const tableName = "users_billing_details";
            
            const data = {
                "user_id": await getuserdata("id"),
                "name": localInvoice.name,
                "address": localInvoice.address,
                "state": localInvoice.state,
                "city": localInvoice.city,
                "pincode": localInvoice.pincode,
                "country": localInvoice.country,
                "phone": localInvoice.phone,
                "email": localInvoice.email,
                "website": localInvoice.website,
                "gst_number": localInvoice.gst_number
            };
            let response;
            if(localInvoice.id) {
                const conditions = {
                    "user_id": await getuserdata("id")
                };
                response = await oneKlicks.update(tableSchema, tableName, data, conditions);
            } else {
                const conditions = {
                    "id": localInvoice.id,
                    "user_id": await getuserdata("id")
                };
                response = await oneKlicks.create(tableSchema, tableName, data, conditions);
            }
            debugLog('response check invoice settings', response);
            if (response.success) {
                toast.success("Invoice settings updated successfully");
            } else {
                toast.error("Failed to update invoice settings. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred while updating invoice settings");
        }
    };


    return (
        <>
            <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
                {userdata.activation_key == null && (
                    <EmailVerify />
                )}

                <section className="dc-haslayout dc-dbsectionspace">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <form className="dc-haslayout dc-user-account">
                                <div className="dc-dashboardbox dc-dashboardtabsholder dc-accountsettingholder">
                                <DashBordmenu title="Account Settings" status={showmenu} onClick={() => { setShowmenu(!showmenu) }} />
                                    <div className="dc-dashboardtabs" style={{ display: window.innerWidth < 576 ? showmenu ? 'block' : 'none' : 'block' }}>
                                        <ul className="dc-tabstitle nav navbar-nav">
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Security & Settings" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Security & Settings");
                                                    }}>
                                                    Security &amp; Settings
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Password" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Password");
                                                    }}>
                                                    Password
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Email Notification" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Email Notification");
                                                    }}>
                                                    Email Notification
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Social Account Details" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Social Account Details");
                                                    }}>
                                                    Social Account Details
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Account Sharing" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Account Sharing");
                                                    }}>
                                                    Account Sharing
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Bank Account Details" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Bank Account Details");
                                                    }}>
                                                    Bank Account Details
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Seo Settings" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Seo Settings");
                                                    }}>
                                                    Seo Settings
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={`${tabsest == "Invoice Settings" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Invoice Settings");
                                                    }}>
                                                    Invoice Settings
                                                </a>
                                            </li>

                                            <li className="nav-item">
                                                <a className={`${tabsest == "Delete Account" ? 'active' : ''} `} href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick("Delete Account");
                                                    }}>
                                                    Delete Account
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    {tabsest == "Security & Settings" && (
                                        <SecuritySettings />
                                    )}
                                    {tabsest == "Password" && (
                                        <Password oldpassword={oldpassword} setOldpassword={setOldpassword} newpassword={newpassword} setNewpassword={setNewpassword} confirmpassword={confirmpassword} setConfirmpassword={setConfirmpassword} />
                                    )}
                                    {tabsest == "Email Notification" && (
                                        <EmailNotification email={email} onEmailChange={setEmail} emailisvalid={emailisvalid} />
                                    )}
                                    {tabsest == "Social Account Details" && (
                                        <SocialAccountDetails />
                                    )}
                                    {tabsest == "Delete Account" && (
                                        <DeleteAccount formData={formData} setFormData={setFormData} />
                                    )}
                                    {tabsest == "Account Sharing" && (
                                        <AccountSharing />
                                    )}
                                    {tabsest == "Seo Settings" && (
                                        <SeoSettings />
                                    )}
                                    {tabsest == "Invoice Settings" && (
                                        <InvoiceSettings localInvoice={localInvoice} setLocalInvoice={setLocalInvoice} />
                                    )}
                                    {tabsest == "Bank Account Details" && (
                                        <BankAccountDetails />
                                    )}
                                </div>

                                <div className="dc-updatall">
                                    <i className="ti-announcement"></i>
                                    <span>Update all the latest changes made by you, by just clicking on Save &amp; Update button.</span>
                                    <a className="dc-btn dc-update-account22" data-id="41742" data-post="181282" href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (tabsest === "Password") {
                                                handlePasswordSubmit(e);
                                            } else if (tabsest === "Email Notification") {
                                                handleEmailSubmit(e);
                                            } else if (tabsest === "Delete Account") {
                                                handleDeleteAccount(e);
                                            } else if (tabsest === "Account Sharing") {
                                                handleAccountSharing(e);
                                            } else if (tabsest === "Invoice Settings") {
                                                handleInvoiceSettings(e);
                                            } else if (tabsest === "Bank Account Details") {
                                                
                                            }
                                        }}
                                    >Save &amp; Update</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AccountSettings;
